/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button } from '@mui/material';

const OperadorFetchErrorAlert = ({ message, onReload }) => (
  <Alert
    severity="warning"
    sx={{ alignItems: 'center', '& .MuiAlert-message': { flex: 1 } }}
    action={
      <Button color="inherit" size="small" variant="outlined" onClick={onReload}>
        Carregar novamente
      </Button>
    }
  >
    {message}
  </Alert>
);

OperadorFetchErrorAlert.propTypes = {
  message: PropTypes.string.isRequired,
  onReload: PropTypes.func.isRequired,
};

export default OperadorFetchErrorAlert;
